// @ts-nocheck
class WIimage extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.loadImage();
        this.openProZoom();
        this.closeProZoom();
        document.addEventListener('imgLoad', ()=>{
            this.loadImage();
        })
    }

    // load image on intersection 
    loadImage() {
        let lazyImages = this.querySelector('img'); 

    let observer = new IntersectionObserver(
        function (entries, observer) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
            let img = entry.target;
            img.src = img.dataset.src;
            img.classList.add('WI_loaded');
            img.classList.remove("WI_lazy");
            observer.unobserve(img);
            }
        });
        },
        {
        rootMargin: "10px", // Load earlier (you can adjust this)
        }
    );
    observer.observe(lazyImages);
    }

    // zoom feature open
    openProZoom() {
        let zoomEnable = this.querySelector('[data-proImg]');
        if (zoomEnable) {
            this.addEventListener('click', (e)=>{
                document.querySelector('.WI_proZoomPop_main').style.display = "block";
                let id = `WI_img_zoom_${e.target.dataset.mediaid}_id`;
                let thumbId = `WI_img_zoomThumb_${e.target.dataset.mediaid}_id`;
                setTimeout(() => {
                    this.scrollToElementWithPercentOffset(id);
                    this.zoomImgThumbClick(thumbId);
                }, 10);
            });
        }
    }

    closeProZoom() {
        document.querySelector('.WI_proZoomPop_headerLeft')?.addEventListener('click', ()=>{clsoe()});
        document.querySelectorAll('.WI_proZoomPop_in_mainImg img')?.forEach(i => {
            i.addEventListener('click', ()=>{clsoe()});
        });
        function clsoe() {
            // Pause all videos in popup before closing
            document.querySelectorAll('.WI_proZoomPop_in_mainImg video').forEach(video => {
                video.pause();
            });
            // Resume videos on product page
            document.querySelectorAll('.WI_productGallery_deskGal_vid video').forEach(video => {
                video.play();
            });
            document.querySelector('.WI_proZoomPop_main').style.display = "none";
            document.querySelectorAll('.WI_proZoomPop_thumb').forEach(t => {
                t.style.opacity = "0.5";
            });
        }
    }
    
scrollToElementWithPercentOffset(id) {
  let container = document.querySelector('.WI_proZoomPop_in_mainImg');
  let target = document.getElementById(id);

  if (container && target) {
    let containerRect = container.getBoundingClientRect();
    let targetRect = target.getBoundingClientRect();

    // Distance from container’s top to target’s top, including current scroll
    let targetOffsetTop = targetRect.top - containerRect.top + container.scrollTop;

    // Calculate the target’s center position within the container
    let targetCenter = targetOffsetTop - (container.clientHeight / 2) + (target.clientHeight / 2);

    // Scroll instantly to center (you can add +200 if you still want offset)
    container.scrollTop = targetCenter;

  } else {
    console.warn('Container or target not found');
  }
}

    zoomImgThumbClick(id) {
        let zoomElement = document.getElementById(id);
        zoomElement.style.opacity = '1';
        let thumbImg = document.querySelectorAll('.WI_proZoomPop_thumb');
        for (let i = 0; i < thumbImg.length; i++) {
            thumbImg[i].addEventListener('click', (e)=>{
                thumbImg.forEach(t => {
                    t.style.opacity = "0.5";
                });
                thumbImg[i].style.opacity = "1";
                let thumbId = `WI_img_zoom_${e.target.dataset.mediaid}_id`;
                this.scrollToElementWithPercentOffset(thumbId);
                // Load and play video if thumbnail points to a video
                let targetElement = document.getElementById(thumbId);
                if (targetElement) {
                    let video = targetElement.querySelector('video');
                    if (video) {
                        let videoSource = video.querySelector('.WI_videoSource');
                        let videoUrl = video.getAttribute('data-videourl');
                        if (videoSource && videoUrl && !videoSource.src) {
                            videoSource.src = videoUrl;
                            video.load();
                        }
                        video.play();
                    }
                }
            });
        }
    }
}

customElements.define('wi-image', WIimage);

// Video popup click handler
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.WI_videoClickOverlay').forEach(overlay => {
        overlay.addEventListener('click', (e) => {
            // Pause the video on product page
            let galleryVideo = e.target.closest('.WI_productGallery_deskGal_vid')?.querySelector('video');
            if (galleryVideo) {
                galleryVideo.pause();
            }

            document.querySelector('.WI_proZoomPop_main').style.display = "block";
            let id = `WI_img_zoom_${e.target.dataset.mediaid}_id`;
            let thumbId = `WI_img_zoomThumb_${e.target.dataset.mediaid}_id`;
            setTimeout(() => {
                scrollToZoomElement(id);
                highlightThumb(thumbId);
                // Load and play the video in popup
                let targetElement = document.getElementById(id);
                if (targetElement) {
                    let video = targetElement.querySelector('video');
                    if (video) {
                        let videoSource = video.querySelector('.WI_videoSource');
                        let videoUrl = video.getAttribute('data-videourl');
                        if (videoSource && videoUrl && !videoSource.src) {
                            videoSource.src = videoUrl;
                            video.load();
                        }
                        video.play();
                    }
                }
            }, 10);
        });
    });
});

function scrollToZoomElement(id) {
    let container = document.querySelector('.WI_proZoomPop_in_mainImg');
    let target = document.getElementById(id);
    if (container && target) {
        let containerRect = container.getBoundingClientRect();
        let targetRect = target.getBoundingClientRect();
        let targetOffsetTop = targetRect.top - containerRect.top + container.scrollTop;
        let targetCenter = targetOffsetTop - (container.clientHeight / 2) + (target.clientHeight / 2);
        container.scrollTop = targetCenter;
    }
}

function highlightThumb(id) {
    let thumbImg = document.querySelectorAll('.WI_proZoomPop_thumb');
    thumbImg.forEach(t => t.style.opacity = "0.5");
    let thumb = document.getElementById(id);
    if (thumb) {
        thumb.style.opacity = '1';
    }
}